import { render } from "./PushNotificationSetup.vue?vue&type=template&id=3cb4e3d6&scoped=true"
import script from "./PushNotificationSetup.vue?vue&type=script&lang=js"
export * from "./PushNotificationSetup.vue?vue&type=script&lang=js"

import "./PushNotificationSetup.vue?vue&type=style&index=0&id=3cb4e3d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb4e3d6"]])

export default __exports__